<template>
  <div></div>
</template>

<script>
export default {
  name: "Desktop",
  mounted() {
    this.$router.push("/scheme-nodes-tree");
  },
};
</script>

<style lang="scss" scoped></style>
